import axios from '@_system/axios/axios.js'
export default {
	path: '/goodsknowledge',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listknowledge(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listknowledge', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	saveknowledge(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/saveknowledge', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateknowledge(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateknowledge/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deleteknowledge(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deleteknowledge/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	aichattest(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/aichattest', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	aichat(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/aichat', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
